import FIELDS from './PoliceReportFields';
import moment from 'moment';
const municipalityPostalCodes = require('./codPostalYcodMunicipio.json');
const municipalities = require('./municipalities.json');
function getParsedReport(item) {
  const parsedReport = {
    id: item.id,
    status: item.status,
    error: item.error,
    [FIELDS.REFERENCE_KEY]: item.booking?.reference,
    batch: item.batch,
    [FIELDS.CONTRACTDATE_KEY]: item.contractDate,
    [FIELDS.ENTRANCE_KEY]: item.entrance,
    [FIELDS.DEPARTURE_KEY]: item.departure,
    [FIELDS.NUMGUESTS_KEY]: item.booking?.paxes || 1,
    [FIELDS.PAYMENTTYPE_KEY]: item.booking?.paymentType,
    [FIELDS.ROLETYPE_KEY]: item.holder ? 'TI' : 'VI',
    [FIELDS.NAME_KEY]: item.name,
    [FIELDS.SURNAME_KEY]: item.surname,
    [FIELDS.SECONDSURNAME_KEY]: item.secondSurname,
    [FIELDS.CONTACTTYPE_KEY]: item.customFields?.email ? 'email' : 'telefono',
    [FIELDS.CONTACTVALUE_KEY]: item.customFields?.email || item.customFields?.phone,
    [FIELDS.DOCUMENTTYPE_KEY]: item.documentType,
    [FIELDS.DOCUMENTNUMBER_KEY]: item.documentNumber,
    [FIELDS.DOCUMENTSUPPORT_KEY]: item.customFields?.document_support_number,
    [FIELDS.BIRTHDATE_KEY]: item.birthDate,
    [FIELDS.COUNTRY_KEY]: item.customFields?.country,
    [FIELDS.GENDER_KEY]: item.gender || 'U',
    [FIELDS.MUNICIPALITY_KEY]: item.customFields?.municipalityCode,
    [FIELDS.MUNICIPALITYNAME_KEY]: item.customFields?.municipality,
    [FIELDS.ZIPCODE_KEY]: item.customFields?.zipCode,
    [FIELDS.ADDRESS_KEY]: item.customFields?.address,
    [FIELDS.FAMILYRELATIONSHIP_KEY]: item.customFields?.relationship,
    [FIELDS.CHILDREN_KEY]: item.booking?.children || 0,
    bookingUUID: item.bookingUuid,
    bookingDate: item.bookingDate,
  };

  return parsedReport;
}

function createReportToApiUpdate(parsedReport, hotelId, platform) {
  const item = {
    id: parsedReport?.contract.id,
    report: {
      status: parsedReport?.report?.status,
      message: parsedReport?.report?.error,
    },
    contract: {
      reference: parsedReport?.contract[FIELDS.REFERENCE_KEY],
      contractDate: getDateInApiFormat(parsedReport?.contract[FIELDS.CONTRACTDATE_KEY]),
      entrance: getDateInApiFormat(parsedReport?.contract[FIELDS.ENTRANCE_KEY]),
      departure: getDateInApiFormat(parsedReport?.contract[FIELDS.DEPARTURE_KEY]),
      paxes: parsedReport?.contract[FIELDS.NUMGUESTS_KEY],
      adults:
        parsedReport?.contract[FIELDS.ADULTS_KEY] || parsedReport?.contract[FIELDS.NUMGUESTS_KEY],
      hotelId,
      platform: platform || '',
      fullEntranceDate:
        parsedReport?.[FIELDS.FULL_ENTRANCE_DATE_KEY] ||
        parsedReport?.contract[FIELDS.ENTRANCE_KEY],
      fullDepartureDate:
        parsedReport?.[FIELDS.FULL_DEPARTURE_DATE_KEY] ||
        parsedReport?.contract[FIELDS.DEPARTURE_KEY],
    },
    payment: {
      type: parsedReport?.contract[FIELDS.PAYMENTTYPE_KEY],
    },
    guests: parsedReport?.guests?.map(guest => {
      return {
        id: guest.id,
        batch: guest.batch,
        holder: guest[FIELDS.ROLETYPE_KEY] === 'TI',
        name: guest[FIELDS.NAME_KEY],
        surname: guest[FIELDS.SURNAME_KEY],
        secondSurname: guest[FIELDS.SECONDSURNAME_KEY],
        documentType: guest[FIELDS.DOCUMENTTYPE_KEY],
        documentNumber: guest[FIELDS.DOCUMENTNUMBER_KEY],
        nationality: guest[FIELDS.NATIONALITY_KEY] || '',
        birthDate: getDateInApiFormat(guest[FIELDS.BIRTHDATE_KEY]),
        customFields: buildGuestCustomFields(guest),
        gender: guest[FIELDS.GENDER_KEY] || 'U',
      };
    }),
  };

  return item;

  function buildGuestCustomFields(guest) {
    const customFields = {
      email: getParsedContactValue('email', guest),
      phone: getParsedContactValue('telefono', guest),
      document_support_number: guest[FIELDS.DOCUMENTSUPPORT_KEY],
      supportDocument: guest[FIELDS.DOCUMENTSUPPORT_KEY],
      country: guest[FIELDS.COUNTRY_KEY],
      zipCode: guest[FIELDS.ZIPCODE_KEY],
      address: guest[FIELDS.ADDRESS_KEY],
      relationship: guest[FIELDS.FAMILYRELATIONSHIP_KEY],
    };

    if (guest.country === 'ESP') {
      customFields.municipalityCode = guest[FIELDS.MUNICIPALITY_KEY];
    } else {
      customFields.municipality = guest[FIELDS.MUNICIPALITYNAME_KEY];
    }
    return customFields;
  }

  function getParsedContactValue(type, report) {
    return report.contactType === type ? report.contactValue : null;
  }
}

function getParsedReports(data) {
  const guestsList = data.items.map(item => {
    return getParsedReport(item);
  });
  data.statusReport = data.statusReport || [];
  data.items = guestsList;
  return data;
}

function getDateInApiFormat(input) {
  const inputDate = moment(input, ['DD-MM-YYYY', 'YYYY-MM-DD']);
  if (inputDate.isValid) {
    const formattedDate = moment(inputDate).format('YYYY-MM-DD');
    return formattedDate;
  } else {
    console.error('Invalid date format');
    return inputDate;
  }
}

function getMunicipalityByPostalCode(postalCode, country, municipality) {
  if (!country || country?.toUpperCase() !== 'ESP') return false;

  if (!postalCode || !municipality) return false;
  const municipalityCode = municipalityPostalCodes.find(
    entry => entry.codigo_postal.toString() === postalCode
  );

  if (!municipalityCode) return false;

  const municipalityCodeStr = municipalityCode.municipio_id.toString().padStart(5, '0');

  if (municipalityCodeStr === municipality?.toString()) return true;

  return false;
}

export { getParsedReports, createReportToApiUpdate, getMunicipalityByPostalCode };
